import CONFIG from '../../globalVariables.js';

class VilleService {
  static async getAll() {
    try {
      const response = await fetch(`${CONFIG.PATH_API}/ville`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
      });
      const data = await response.json();
      if (!response.ok || !data.success) {
        throw new Error(data.message || 'Erreur récupération villes');
      }
      return data.data;
    } catch (error) {
      console.error('🚨 Erreur getAll villes:', error);
      throw error;
    }
  }

  static async create(payload) {
    try {
      const response = await fetch(`${CONFIG.PATH_API}/ville`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
      const data = await response.json();
      if (!response.ok || !data.success) {
        throw new Error(data.message || 'Erreur création ville');
      }
      return data.data;
    } catch (error) {
      console.error('🚨 Erreur create ville:', error);
      throw error;
    }
  }

  static async update(id, payload) {
    try {
      const response = await fetch(`${CONFIG.PATH_API}/ville/${id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
      const data = await response.json();
      if (!response.ok || !data.success) {
        throw new Error(data.message || 'Erreur mise à jour ville');
      }
      return data.data;
    } catch (error) {
      console.error('🚨 Erreur update ville:', error);
      throw error;
    }
  }

  static async remove(id) {
    try {
      const response = await fetch(`${CONFIG.PATH_API}/ville/${id}`, {
        method: 'DELETE'
      });
      const data = await response.json();
      if (!response.ok || !data.success) {
        throw new Error(data.message || 'Erreur suppression ville');
      }
      return data.data;
    } catch (error) {
      console.error('🚨 Erreur remove ville:', error);
      throw error;
    }
  }

  static async getByDepartement(departementId) {
    try {
      const response = await fetch(`${CONFIG.PATH_API}/ville/departement/${departementId}`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
      });
      const data = await response.json();
      if (!response.ok || !data.success) {
        throw new Error(data.message || 'Erreur récupération villes par département');
      }
      return data.data;
    } catch (error) {
      console.error('🚨 Erreur getByDepartement villes:', error);
      throw error;
    }
  }
}

export default VilleService;